import React from 'react'

import axios from 'axios'
import { useSelector } from 'react-redux';
import { EMPLOYEES_API } from '../../../../Utilities/APIs'

function CreateEmployee({
  setShowModal, setShowCreateEmployee, targetID, triggerFetch
}) {

  const { employee } = useSelector(state => state.auth)
  console.log("🚀 ~ file: CreateEmployee.js:12 ~ employee:", employee)

  console.log(targetID);

  async function handleCreateAdmin(e) {
    e.preventDefault()

    const config = {
      headers: {
        Authorization: `Bearer ${employee.token}`
      }
    }
    console.log(config);
    const response = await axios.patch(EMPLOYEES_API + 'createAdminToEmployeeBySuperAdmin/' + targetID, {}, config)

    if (response) {
      setShowModal(false);
      triggerFetch()
    }
  }
  return (
    <div className='modal_delete_content'>
      <p style={{textAlign: 'center'}}>
        Are you sure you want to remove admin access from {employee?.name}?
      </p>

      <div className="modal_group_buttons ">
        <button
          className="delete"
          onClick={handleCreateAdmin}
        >Remove</button>

        <button className="cancel" onClick={() => {
          setShowModal(false);
          setShowCreateEmployee(false);
        }}>Cancel</button>
      </div>

    </div>
  )
}

export default CreateEmployee